import DeleteIcon from '@mui/icons-material/Delete';
import InfoIcon from '@mui/icons-material/Info';
import ModeEditOutlineIcon from '@mui/icons-material/ModeEditOutline';
import SsidChartIcon from '@mui/icons-material/SsidChart';
import { GridActionsCellItem } from '@mui/x-data-grid';
import placeholderImage from 'assets/images/placeholder.svg';
import ColImage from 'components/shared/Table/ColImage';

import TableActionButtons from '../../components/shared/TableActionButtons/TableActionButtons';

const useProductListTableColumns = (
  goToInfoPage,
  goToGraphPage,
  deleteItem,
  editItem,
  apiRef,
  permissions = {},
) => {
  const {
    canDetail = false,
    canGraph = false,
    canEdit = false,
    canDelete = false,
  } = permissions;

  const canViewActions = canDetail || canGraph || canEdit || canDelete;

  const columnsData = [
    {
      field: 'image',
      headerName: 'تصویر',
      flex: 0.3,
      minWidth: 120,
      editable: false,
      renderCell: params => {
        apiRef.current = params.api;
        return (
          <ColImage
            src={params.row.imageURL || placeholderImage}
            alt={params.row.title}
          />
        );
      },
    },

    {
      field: 'title',
      headerName: 'عنوان',
      flex: 1,
      minWidth: 230,
      editable: false,
    },

    ...(canViewActions
      ? [
          {
            field: 'actions',
            headerName: 'عملیات',
            type: 'actions',
            flex: 0.5,
            minWidth: 300,
            align: 'right',
            getActions: params => {
              const buttons = [
                canDetail
                  ? {
                      label: 'جزئیات',
                      Icon: InfoIcon,
                      onClick: goToInfoPage(params.row),
                      color: 'primary',
                    }
                  : null,
                canGraph
                  ? {
                      label: 'گراف',
                      Icon: SsidChartIcon,
                      onClick: goToGraphPage(params.row),
                      color: 'warning',
                    }
                  : null,
              ].filter(Boolean);

              return [
                buttons.length ? (
                  <TableActionButtons key={10} buttons={buttons} />
                ) : null,
                canEdit ? (
                  <GridActionsCellItem
                    key={3}
                    icon={<ModeEditOutlineIcon />}
                    label="ویرایش"
                    onClick={editItem(params.row)}
                    showInMenu
                  />
                ) : null,
                canDelete ? (
                  <GridActionsCellItem
                    key={4}
                    icon={<DeleteIcon />}
                    label="حذف"
                    onClick={deleteItem(params.row)}
                    showInMenu
                  />
                ) : null,
              ].filter(Boolean);
            },
          },
        ]
      : []),
  ];

  return [columnsData];
};

export default useProductListTableColumns;
